function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  &&& {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import css from "@styled-system/css";
import * as R from "ramda";
import styled from "styled-components";
import { borders, color, flexbox, layout, position, space } from "styled-system";
var BANNER_HEIGHT = 300;
var calculateSpacerPadding = function(props) {
    var _props_theme;
    var _props_size;
    var size = (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : "md";
    var padding = ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.space) ? props.theme.space[size] / 2 : 0;
    return props.vertical ? "".concat(padding, "px 0") : "0 ".concat(padding, "px");
};
export var Box = styled.div(color, layout, position, space, borders);
export var Column = styled.div(function(param) {
    var switchAt = param.switchAt;
    return css({
        boxSizing: "border-box",
        display: "flex",
        flexBasis: 0,
        flexDirection: _to_consumable_array(R.isNil(switchAt) ? [] : Array(switchAt + 1).fill("row")).concat([
            "column"
        ]),
        justifyContent: "center"
    });
}, borders, color, flexbox, layout, space);
export var Row = styled.div(function(param) {
    var switchAt = param.switchAt;
    return css({
        boxSizing: "border-box",
        display: "flex",
        flexDirection: _to_consumable_array(R.isNil(switchAt) ? [] : Array(switchAt + 1).fill("column")).concat([
            "row"
        ]),
        flexWrap: "wrap",
        width: "100%"
    });
}, borders, color, flexbox, layout, space);
export var Spacer = styled.span(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, calculateSpacerPadding);
var banner = function(param) {
    var _param_dark = param.dark, dark = _param_dark === void 0 ? false : _param_dark;
    return css({
        "& > h3": {
            marginBottom: 0
        },
        backgroundColor: dark ? "greys.1000" : "white",
        boxSizing: "content-box",
        display: "flex",
        flexDirection: "column",
        h1: {
            color: dark ? "purples.300" : "black"
        },
        justifyContent: "flex-end",
        minHeight: BANNER_HEIGHT,
        paddingX: "xl",
        paddingY: "md",
        position: "relative"
    });
};
export var PageBanner = styled.div.attrs(function(param) {
    var dark = param.dark;
    return {
        className: dark ? "page-banner dark" : "light"
    };
})(_templateObject1(), function(props) {
    return banner(props);
});

//# sourceMappingURL=components.js.map